__turbopack_context__.v({
  "Body": "GBQoIG_Body",
  "BottomButton": "GBQoIG_BottomButton",
  "CloseButton": "GBQoIG_CloseButton",
  "Content": "GBQoIG_Content",
  "Content--Sidebar": "GBQoIG_Content--Sidebar",
  "Header": "GBQoIG_Header",
  "IsOpen": "GBQoIG_IsOpen",
  "Overlay": "GBQoIG_Overlay",
  "Root": "GBQoIG_Root",
  "Sidebar": "GBQoIG_Sidebar",
  "Title": "GBQoIG_Title",
  "ToggleButton": "GBQoIG_ToggleButton",
  "show": "GBQoIG_show",
  "skeleton-loading": "GBQoIG_skeleton-loading",
});
